module.exports = __webpack_public_path__ + "static/banner-4d8a7c8da866983a24e7106f60855dee.jpg";